import { create } from "zustand";

// Mirrors backend ``app.auth.roles.Role`` verbatim. Keep in lockstep —
// the permission matrix in ``usePermissions`` keys off these strings.
export type Role = "TESTRAD" | "RADIOLOGIST" | "ADMIN" | "SUPER_ADMIN";

export interface AuthUser {
  id: string;
  username: string;
  role: Role;
  full_name: string | null;
  email: string | null;
  active: boolean;
  /** Registration / provider number. ``GET /auth/me`` (UserPublic) has
   *  always returned it; it was just missing from this type. SignDialog
   *  prefills the signature's licence field from it so the signer does
   *  not retype it on every report. */
  license_number?: string | null;
}

interface AuthState {
  // Access token lives ONLY in memory. Persisting it to localStorage or
  // sessionStorage would convert any frontend XSS into a PHI exfiltration
  // channel. Refresh is delegated to an HttpOnly cookie set by the backend.
  accessToken: string | null;
  user: AuthUser | null;
  setAccessToken: (token: string | null) => void;
  setUser: (user: AuthUser | null) => void;
  setSession: (token: string, user: AuthUser) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  setAccessToken: (token) => set({ accessToken: token }),
  setUser: (user) => set({ user }),
  setSession: (token, user) => set({ accessToken: token, user }),
  clearAuth: () => set({ accessToken: null, user: null }),
}));
